<template>
  <div class="buttonList-box">
    <div class="nav-box">
      <div class="nav-item-type" v-for="(item,index) in buttonList" :key="index" :class="active === item.value? 'active-nav-item':''"
           @click="navChange(item)">
         <img v-if="active != item.value" :src="item.logo" />
         <img v-if="active == item.value" :src="item.active" />
        <div class="nav-text">{{item.name}}</div>
      </div>
    </div>
    <!--        <ul class="nav">-->
    <!--            <li class="list" @click="navChange(item)"-->
    <!--                :class="`${active === item.value ? 'show' : ''}`" v-for="item in listGroup">-->
    <!--                {{ item.name }}-->
    <!--                <div class="icon-bg">-->
    <!--                    <img :src="item.logo"/>-->
    <!--                </div>-->
    <!--                <div class="list-bg"></div>-->
    <!--            </li>-->
    <!--        </ul>-->
    <!--        <div class="nav-font"></div>-->
    <!--        <div class="nav-back"></div>-->
  </div>
</template>

<script>
import { EventBus } from "@/utils/eventBus";
import {getButtonList} from "@/service/dashboard";

export default {
  name: "navigation",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    activeScreen: ""
  },
  watch:{
    activeScreen(){
      this.active = "all";
    }
  },
  data() {
    return {
      active: "all",
      buttonList: [
        {
          name: "总览",
          value: "all",
          logo: require("../assets/buttonList/comprehensive-logo.png"),
          active: require("../assets/buttonList/comprehensive-logo-active.png")
        },
        {
          name: "证书",
          value: "pki",
          logo: require("@/assets/buttonList/certificate-logo.png"),
          active: require("../assets/buttonList/certificate-logo-active.png")
        },
        {
          name: "路由",
          value: "bgp",
          logo: require("@/assets/buttonList/router-logo.png"),
          active: require("../assets/buttonList/router-logo-active.png")
        },
        {
          name: "网站",
          value: "web",
          logo: require("@/assets/buttonList/web-logo.png"),
          active: require("../assets/buttonList/web-logo-active.png")
        },
        {
          name: "域名",
          value: "dns",
          logo: require("@/assets/buttonList/domain-logo.png"),
          active: require("../assets/buttonList/domain-logo-active.png")
        },
        {
          name: "邮件",
          value: "email",
          logo: require("@/assets/buttonList/email-logo.png"),
          active: require("../assets/buttonList/email-logo-active.png")
        }
      ]
    };
  },
  mounted() {
    this.getBtnList();
  },
  methods: {
    getBtnList() {
      getButtonList().then(res => {

      });
      this.$emit("btnListVal", this.active);
    },
    navChange(item, isChange) {
      if (this.disabled) {
        return;
      }
      this.active = item.value;
      localStorage.setItem("btnKey", this.active);
      EventBus.$emit("getLocalStoryCallSomeMethod");
      this.$emit("btnListVal", item.value, isChange);
    }
  }
};
</script>

<style scoped lang="less">
.buttonList-box {
  font-family: AlibabaRegular;
  position: absolute;
  left: 1212px;
  bottom: 180px;
  width: 192px;
  height: 115px;
  background-size: 100%;
    z-index: 8;
  .nav-box {
    width: 192px;
    height: 115px;
    position: absolute;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .nav-item-type {
      cursor: pointer;
      border-radius: 7px;
      width: 91px;
      height: 33px;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      background: linear-gradient(270deg, rgba(73, 74, 98, 0.4) 0%, rgba(108, 111, 157, 1) 100%);
      background-size: 100%;
      box-sizing: border-box;
      img{
        width: 22px;
        height: 22px;
      }
    }
    .active-nav-item {
      background: linear-gradient(270deg, rgba(113, 125, 219, 0.4) 0%, rgba(75, 90, 201, 1) 100%);
    }
    .nav-text {
      font-size: 14px;
      font-weight: 700;
      color: #FFF;
    }
  }
}
</style>
